import React from 'react';
interface PricingCardProps {
  title: string;
  emoji: string;
  description: string;
  features: string[];
  originalPrice: string;
  price: string;
  ctaText: string;
  isCenter?: boolean;
  savings?: string;
  ctaHref?: string;
}
function PricingCard({
  title,
  emoji,
  description,
  features,
  originalPrice,
  price,
  ctaText,
  isCenter = false,
  savings,
  ctaHref = '#'
}: PricingCardProps) {
  return <div className={`relative flex flex-col rounded-2xl p-6 ${isCenter ? 'bg-[#0d0d00] border-2 border-[#FFD700] shadow-[0_0_40px_rgba(255,215,0,0.3)] scale-100 md:scale-105 z-10' : 'bg-[#0a0a0a] border border-[#FFD700]/30'}`} data-id="element-152">
      {isCenter && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#FFD700] text-black font-black text-xs px-4 py-1.5 rounded-full animate-pulse whitespace-nowrap" data-id="element-153">
          ⭐ MÁS ELEGIDO — MEJOR VALOR
        </div>}

      <div className="text-center mb-5" data-id="element-154">
        <div className="text-3xl mb-2" data-id="element-155">{emoji}</div>
        <h3 className={`font-black text-xl mb-1 ${isCenter ? 'text-[#FFD700]' : 'text-white'}`} data-id="element-156">
          {title}
        </h3>
        <p className="text-gray-400 text-sm" data-id="element-157">{description}</p>
      </div>

      <ul className="space-y-2 mb-6 flex-1" data-id="element-158">
        {features.map((f, i) => <li key={i} className="flex items-start gap-2 text-sm text-white" data-id="element-159">
            <span className="text-green-400 flex-shrink-0" data-id="element-160">✅</span>
            <span data-id="element-161">{f}</span>
          </li>)}
      </ul>

      <div className="text-center mb-5" data-id="element-162">
        <div className="text-gray-500 line-through text-sm mb-1" data-id="element-163">
          {originalPrice}
        </div>
        <div className={`font-black text-4xl ${isCenter ? 'text-[#FFD700]' : 'text-white'}`} data-id="element-164">
          {price}
        </div>
        <div className="text-gray-400 text-xs mt-1" data-id="element-165">ARS</div>
        {savings && <div className="text-green-400 text-sm font-bold mt-1" data-id="element-166">{savings}</div>}
      </div>

      <a href={ctaHref} className={`btn-gold-pulse w-full text-center font-black py-4 rounded-xl text-base transition-colors ${isCenter ? 'bg-[#FFD700] text-black hover:bg-yellow-300 text-lg' : 'bg-[#FFD700] text-black hover:bg-yellow-300'}`} data-id="element-167">
        {ctaText}
      </a>

      {isCenter && <p className="text-gray-400 text-xs text-center mt-3" data-id="element-168">
          La opción más elegida por docentes que enseñan en los dos niveles
        </p>}
    </div>;
}
export function PricingSection() {
  return <section id="pricing" className="w-full bg-black py-16 px-4 pt-[20px] pb-[20px]" data-id="element-169">
      <div className="max-w-5xl mx-auto" data-id="element-170">
        <h2 className="text-3xl sm:text-4xl font-black text-[#FFD700] text-center mb-12" data-id="element-171">
          Elegí tu PROFEPACK:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center mb-10" data-id="element-172">
          <div className="order-2 md:order-1" data-id="element-173">
            <PricingCard emoji="📘" title="PRIMARIA" description="Para docentes de Música de primaria (1° a 6° grado)" features={['6 Tomos completos', '+120 clases con guion', 'Planificaciones para carpeta', 'Rúbricas por grado', '6 Bonos incluidos', 'Acceso inmediato PDF']} originalPrice="$53.000 ARS" price="$16.990" ctaText="→ QUIERO PRIMARIA" ctaHref="https://www.profepack.com/cart/48106544300288:1" data-id="element-174" />
          </div>
          <div className="order-1 md:order-2" data-id="element-175">
            <PricingCard emoji="🏆" title="PACK COMPLETO" description="Para docentes de Música de primaria y secundaria (Todos los niveles)" features={['12 Tomos completos', '+240 clases con guion', 'Planificaciones para todos los niveles', 'Rúbricas primaria y secundaria', '6 Bonos incluidos', 'Acceso inmediato PDF']} originalPrice="$35.980 ARS" price="$27.990" ctaText="→ QUIERO MI PROFEPACK COMPLETO" isCenter={true} savings="✅ AHORRÁS $7.990 ARS" ctaHref="https://www.profepack.com/cart/47599804809472:1" data-id="element-176" />
          </div>
          <div className="order-3 md:order-3" data-id="element-177">
            <PricingCard emoji="📗" title="SECUNDARIA" description="Para docentes de Música de secundaria (1° a 6° año)" features={['6 Tomos completos', '+120 clases con guion', 'Planificaciones para carpeta', 'Rúbricas por año', '6 Bonos incluidos', 'Acceso inmediato PDF']} originalPrice="$53.000 ARS" price="$18.990" ctaText="→ QUIERO SECUNDARIA" ctaHref="https://www.profepack.com/cart/48106544333056:1" data-id="element-178" />
          </div>
        </div>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-400 bg-[#0a0a0a] border border-[#FFD700]/20 rounded-xl py-4 px-6" data-id="element-179">
          <span data-id="element-180">🔒 Pago 100% seguro</span>
          <span data-id="element-181">⚡ Acceso en 5 minutos</span>
          <span data-id="element-182">🛡️ Garantía 7 días</span>
          <span data-id="element-183">💳 Mercado Pago / Tarjeta / Transferencia</span>
        </div>
      </div>
    </section>;
}